"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlternatingRowClass = getAlternatingRowClass;
exports.getFixedColumnClass = getFixedColumnClass;
exports.getFirstRowClass = getFirstRowClass;
exports.getLastRowClass = getLastRowClass;
exports.getColumnKeysInOrder = getColumnKeysInOrder;
exports.createHeaderRow = createHeaderRow;

var _naturalOrderby = require("natural-orderby");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getAlternatingRowClass(columnIndex, rowIndex, _ref) {
  var fixedColumnCount = _ref.fixedColumnCount;
  return rowIndex % 2 !== 0 && columnIndex >= fixedColumnCount ? 'multi-grid__body--accent-row' : '';
}

function getFixedColumnClass(columnIndex, _ref2) {
  var fixedColumnCount = _ref2.fixedColumnCount;
  return columnIndex < fixedColumnCount ? 'multi-grid__body--fixed-column' : '';
}

function getFirstRowClass(rowIndex) {
  return rowIndex === 1 ? 'multi-grid__body--first-row' : '';
}

function getLastRowClass(rowIndex, numberOfRows) {
  return rowIndex === numberOfRows ? 'multi-grid__body--last-row' : '';
}

function getColumnKeysInOrder(resultConfiguration) {
  var RESULT_CONFIGURATION_COLUMN_ORDER_KEY_NAME = 'columnOrder';
  var ORDER_ASCENDING = 'asc';
  var orderedColumns = (0, _naturalOrderby.orderBy)(resultConfiguration, [RESULT_CONFIGURATION_COLUMN_ORDER_KEY_NAME], [ORDER_ASCENDING]);
  return orderedColumns.map(function (column) {
    return column.fieldName;
  });
}

function createHeaderRow(rows, columns) {
  var newRow = columns.reduce(function (result, column) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, column, null));
  }, {});
  return rows.length !== 0 ? [newRow].concat(_toConsumableArray(rows)) : [newRow];
}